import RecessAPI from '@services/RecessAPI'


axios = require 'axios'

class HubspotService
  @submitHubspotForm: (email, route) ->
    try
      utmParams = {} if !utmParams?
      headers = RecessAPI.headers()
      hubspotURL = process.env.VUE_APP_HUBSPOT_SUBMIT_FORM_URL
      payload = {
        fields: [
          {
            name: 'email',
            value: email
          }
        ],
        context: {}
      }
      for field in ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content']
        payload.fields.push({ name: field, value: route.query[field] }) if route.query[field]?
      payload.context.hutk = @hubspotCookieId() if @hubspotCookieId()?
      axios.post hubspotURL, payload, { headers }
    catch err
      console.log err

  @hubspotCookieId: -> document.cookie.split("hubspotutk=").pop()?.split(";")[0] if document.cookie.includes "hubspotutk"

export default HubspotService